import axios, { AxiosError, AxiosInstance, AxiosResponse } from "axios";
import { captureMessage, captureException } from "@sentry/react";
import { defaultAxiosRequestConfig, DefaultAxiosRequestConfig } from "~/api/apiMethods";

export const NETWORK_ERROR_MESSAGE =
  "Не удалось связаться с сервером. Проверьте подключение к интернету и попробуйте ещё раз. Если проблема повторяется, свяжитесь с нами — мы поможем закончить подключение.";

export const clientApi: AxiosInstance = axios.create({
  baseURL: import.meta.env.VITE_APP_API_URL,
  headers: { "Content-Type": "application/json" }
});

clientApi.interceptors.response.use(
  response => response,
  async (error: AxiosError & { config: DefaultAxiosRequestConfig }) => {
    const config = error.config;

    if (!config || !config?.retry) return Promise.reject(error);

    const isNetworkError =
      error?.message?.includes("timeout") || error?.message?.includes("Network Error");

    if (!isNetworkError) return Promise.reject(error);

    config.retry -= 1;

    await new Promise(resolve =>
      setTimeout(resolve, config.retryDelay || defaultAxiosRequestConfig.retryDelay)
    );

    return clientApi(config);
  }
);

clientApi.interceptors.response.use(
  (response: AxiosResponse) => {
    const data = response?.data as any;

    if (data?.success === 0 && Array.isArray(data?.errors)) {
      data.errors.forEach((err: any) => {
        // в сентри не кладем ошибки полей,
        // TODO: слать в аналитику для дальнейшего анализа
        if (err?.code === "field_validation") {
          return;
        }

        captureMessage(`API Error: ${err?.code ?? "unknown_code"}`, {
          level: err?.code ? "warning" : "error",
          tags: {
            api_endpoint: response.config?.url ?? "unknown",
            http_status: response.status.toString(),
            api_code: err?.code ?? "unknown"
          },
          extra: {
            message: err?.message,
            target: err?.data?.target,
            // response_data: err?.data,
            method: response.config?.method
          }
        });
      });

      // Создаём искусственную ошибку, чтобы axios цепочка знала, что это failure
      // const logicalError = new Error("API logical error");
      // (logicalError as any).response = response;
      // return Promise.reject(logicalError);
    }

    return response;
  },
  (error: AxiosError & { userMessage?: string }) => {
    if (!error.response) {
      error.userMessage = NETWORK_ERROR_MESSAGE;
    }

    captureException(error);
    return Promise.reject(error);
  }
);
